var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareBoxFill = function SvgShareBoxFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.2 3.898v1.8H5.7v12.6h12.6v-4.5h1.8v5.4a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9v-14.4a.9.9 0 0 1 .9-.9zm6.936 4.237L12 13.27l-1.273-1.273 5.137-5.136L12.9 3.898h7.2v7.2z"
  })));
};
export default SvgShareBoxFill;